import { REQUEST_START, REQUEST_FINISH } from './actionTypes';

function fetchPending() {
  return {
    type: REQUEST_START    
  }
}

function fetchFinish() {
  return {
    type: REQUEST_FINISH
  }
}

export {
  fetchPending,
  fetchFinish
}